import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'

const StoreWorkingHoursLine = ({ label, value }) =>
  <Wrapper data-at-store-workinghours-time >
    <Columns width="60% 40%">
      <Text inline bolder>{ label }</Text>
      <Text inline>{ value }</Text>
    </Columns>
  </Wrapper>

export default StoreWorkingHoursLine

StoreWorkingHoursLine.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
}

const Wrapper = styled.div`
  & + & {
    padding-top: 5px;
  }
`
